export const CACHED_DATA_MEDIA_RESOURCE_TYPES = 'mediaResourceTypes';
export const CACHED_DATA_MODULES = 'modules';
export const CACHED_DATA_STAFF = 'staff';
export const CACHED_DATA_STAFF_TRACKED = 'trackedStaff';
export const CACHED_DATA_PATENTS_AMOUNT = 'patentsAmount';
export const CACHED_DATA_CATEGORIES = 'categories';
